import React from "react";
import "./RoutineConfig.scss";
import Card from "../../../components/Card/Card";
import { Link } from "react-router-dom";
import { MdMoreTime } from "react-icons/md";
import { MdOutlineRemoveRedEye } from "react-icons/md";

const RoutineConfig = () => {
  return (
    <div className="settingPageContainer">
      <div className="settingPageContents">
        <div className="headerTitle">Routine</div>
        <div className="settingsCard">
          <Link to="group" style={{ textDecoration: "none" }}>
            <Card icon={<MdMoreTime />} title="Grouped Routine" />
          </Link>
          <Link to="list" style={{ textDecoration: "none" }}>
            <Card icon={<MdMoreTime />} title="Individual Routine" />
          </Link>
          <Link to="view/table" style={{ textDecoration: "none" }}>
            <Card icon={<MdOutlineRemoveRedEye />} title="View Routine" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RoutineConfig;
